import axios from "axios";
import { SERVER_URL } from "../../../../config/env";
import authHeader from "../../../../2_ksbHub/utils/auth/auth-header";

const reservationService = {
  /**
   * =========================================================
   * ✅ RESERVE SLOT
   * =========================================================
   */
  async reserveSlot(slotId, action) {
    const res = await axios.post(
      SERVER_URL + "bsz/reservations/slot",
      { slotId, action },
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },

  /**
   * =========================================================
   * ✅ REMOVE RESERVATION
   * =========================================================
   */
  async removeReservation() {
    const res = await axios.delete(SERVER_URL + "bsz/reservations", {
      headers: authHeader(),
    });

    return res.data;
  },
};

export default reservationService;
